import { defineMessages } from 'react-intl';

export const authMessages = defineMessages({
  emailAddress: {
    id: 'auth.emailAddress',
    defaultMessage: 'Email address',
  },
  username: {
    id: 'auth.username',
    defaultMessage: 'Username',
  },
  password: {
    id: 'auth.password',
    defaultMessage: 'Password',
  },
  lastName: {
    id: 'auth.lastName',
    defaultMessage: 'Last name',
  },
  firstName: {
    id: 'auth.firstName',
    defaultMessage: 'First name',
  },
  middleName: {
    id: 'auth.middleName',
    defaultMessage: 'Middle name (Optional)',
  },
  preferredFirstName: {
    id: 'auth.preferredFirstName',
    defaultMessage: 'Preferred first name (Optional)',
  },
  createAccount: {
    id: 'auth.createAccount',
    defaultMessage: 'Create account',
  },
  emailValidationMessage: {
    id: 'auth.emailValidationMessage',
    defaultMessage: 'Please provide a valid email address (name@example.com).',
  },
});
